
import React, { useState, useEffect } from "react";
import MainLayout from '../layouts/MainLayout';
import { Popover } from 'antd';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { GET_USERS, USER_INACTIVE } from "../services/userServices";
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import EditUser from './../components/users/edit';
import AddUser from "../components/users/add";
import { fetchOrganizations } from "../services/organizationServices";
import { Select } from "antd";
import { fetchWithAuth } from "../utils/api";
import { BASE_IMAGE_API_GET } from "../services/baseServices";
const { Option } = Select;


function Users() {

    const [sessionUserData, setSessionUserData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [eitData, setEditData] = useState([]);
    const [organizationsData, setOrganizationsData] = useState([]);
    const [selectedOrgId, setSelectedOrgId] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    const fetchData = async () => {
        setDataLoading(true);
        try {
            const response = await fetchWithAuth(`${GET_USERS}?OrgId=${selectedOrgId}`, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                setUsersData(data.ResultData || []);
            } else {
                console.error('Failed to fetch attendance data:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching attendance data:', error.message);
        } finally {
            setDataLoading(false);
        }
    };

    const getOrganizations = async () => {
        try {
            const data = await fetchOrganizations();
            setOrganizationsData(data);
        } catch (error) {
            console.error('Failed to load organizations:', error);
        } finally {
            console.log('Organization fetch completed');
        }
    };

    useEffect(() => {
        getOrganizations();
    }, []);

    useEffect(() => {
        if (sessionUserData.OrgId && selectedOrgId) {
            fetchData();
        }
    }, [sessionUserData, selectedOrgId]);

    const filteredData = Array.isArray(usersData)
        ? usersData.filter((item) => {
            const userName = item?.Name?.toLowerCase() || "";
            const email = item?.Email?.toLowerCase() || "";
            const role = item?.RoleName?.toLowerCase() || "";
            const dept = item?.DeptName?.toLowerCase() || "";

            const query = searchQuery.toLowerCase();

            return (
                userName.includes(query) ||
                email.includes(query) ||
                role.includes(query) ||
                dept.includes(query)
            );
        })
        : [];

    const handleEdit = (item) => {
        setEditData(item);
    };

    const recordsPerPage = 10;
    const totalPages = Math.ceil(filteredData?.length / recordsPerPage);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    const handleDeleteUser = async (item) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete user?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const now = new Date();
                    const currentTime = `${now.getFullYear()}-${String(
                        now.getMonth() + 1
                    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
                        now.getHours()
                    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
                        now.getSeconds()
                    ).padStart(2, "0")}.000`;

                    const payload = {
                        UpdatedBy: sessionUserData.Id,
                        Id: item.Id
                    };

                    const response = await fetchWithAuth(`${USER_INACTIVE}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    });
                    const result = await response.json();

                    if (result.ResultData?.Status === 'Success') {
                        fetchData();
                        Swal.fire("Success!", "User has been deleted.", "success");
                    } else {
                        const errorData = await response.json();
                        Swal.fire("Error!", errorData.ResultData?.ResultMessage || "Failed to delete user.", "error");
                    }
                } catch (error) {
                    console.error("Error during user delete:", error.message);
                    Swal.fire("Error!", "An unexpected error occurred.", "error");
                }
            }
        });
    };

    return (
        <MainLayout>
            <div className='content'>
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Users</h4>
                            <h6>Manage your users</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>

                    </ul>
                    <div className={`page-btn`}>
                        <a href="#" className="btn btn-primary"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightAdd"
                            aria-controls="offcanvasRightAdd"
                        >
                            <i className="ti ti-circle-plus me-1"></i>New User
                        </a>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set">
                            <div className="search-input">
                                <span className="btn-searchset"><i className="ti ti-search fs-14 feather-search"></i></span>
                                <input
                                    type="search"
                                    className="form-cotrol"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-2 col-12 mb-2">
                            <label className="form-label">Organization<span className="text-danger">*</span></label>
                            <Select
                                showSearch
                                placeholder="Choose Organization"
                                className="w-100"
                                value={selectedOrgId}
                                onChange={(value) => setSelectedOrgId(value)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {organizationsData?.map((org) => (
                                    <Option key={org.OrgId} value={org.OrgId}>
                                        {org.OrgName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="no-sort">#</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>Gender</th>
                                        <th>Department</th>
                                        <th>Role</th>
                                        <th className="no-sort">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {dataLoading ? (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <div className="container"></div>
                                            </td>
                                        </tr>
                                    ) : currentRecords && currentRecords.length > 0 ? (
                                        currentRecords.map((item, index) => (
                                            <tr>
                                                <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                <td>
                                                    <a className="text-gray-800 text-hover-primary mb-1">{item.Name}</a>
                                                </td>
                                                <td className="text-info">
                                                    <div
                                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                                        style={{
                                                            width: "60px",
                                                            height: "60px",
                                                            border: "2px solid #e0f2fe",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                                                            overflow: "hidden",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => setSelectedImage(`${BASE_IMAGE_API_GET}${item.ImageUrl}`)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#imagePreviewModal"
                                                    >
                                                        <img
                                                            src={`${BASE_IMAGE_API_GET}${item.ImageUrl}`}
                                                            alt="Img"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                                padding: "4px",
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <a className="text-primary mb-1">{item.Email}</a>
                                                </td>
                                                <td>{item.Mobile || 'N/A'}</td>
                                                <td>{item.Gender === 1 ? 'Male' : 'Female'}</td>
                                                <td>{item.DeptName || 'N/A'}</td>
                                                <td className="text-info">{item.RoleName || 'N/A'}</td>
                                                <td className="">
                                                    <Popover
                                                        placement="bottom"
                                                        content={
                                                            <div style={{ width: '8rem' }}>
                                                                <p
                                                                    style={{ cursor: 'pointer' }}
                                                                    className="text-hover-warning"
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#offcanvasRightEdit"
                                                                    aria-controls="offcanvasRightEdit"
                                                                    onClick={() => handleEdit(item)}
                                                                >
                                                                    <i className="fa-regular fa-pen-to-square me-2 text-info"></i>
                                                                    Edit
                                                                </p>
                                                                <p
                                                                    style={{ cursor: 'pointer' }}
                                                                    className="text-hover-warning"
                                                                    onClick={() => handleDeleteUser(item)}
                                                                >
                                                                    <i className="fa-regular fa-trash-can text-danger me-2"></i>
                                                                    Delete
                                                                </p>
                                                            </div>
                                                        }
                                                        trigger="hover"
                                                    >
                                                        <button
                                                            className="btn"
                                                        >
                                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>
                                                    </Popover>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <p>No Data Available</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="dt-paging paging_simple_numbers">
                                <nav aria-label="pagination">
                                    <ul className="pagination">
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link previous"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === 1}
                                                aria-label="Previous"
                                                onClick={handlePrevious}
                                            >
                                                <i className="previous"></i>
                                            </button>
                                        </li>

                                        {/* Page Numbers */}
                                        {getPaginationNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-current={page === currentPage ? "page" : undefined}
                                                    onClick={() => handlePageClick(page)}
                                                    disabled={page === "..."}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        {/* Next Button */}
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link next"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === totalPages}
                                                aria-label="Next"
                                                onClick={handleNext}
                                            >
                                                <i className="next"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div
                            className="modal fade"
                            id="imagePreviewModal"
                            tabIndex="-1"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Image Preview</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body text-center p-5">
                                        {selectedImage ? (
                                            <img
                                                src={selectedImage}
                                                alt="Enlarged Preview"
                                                className="img-fluid shadow"
                                                style={{
                                                    maxHeight: '75vh',
                                                    borderRadius: '8px',
                                                    objectFit: 'contain'
                                                }}
                                                // Error handling if the URL is broken
                                                onError={(e) => {
                                                    e.target.src = 'https://via.placeholder.com/400?text=Image+Not+Found';
                                                }}
                                            />
                                        ) : (
                                            <div className="spinner-border text-primary" role="status"></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddUser />
            <EditUser editObj={eitData} />
        </MainLayout>
    )
}

export default Users